export default function ManifestoSection() {
  return (
    <section id="about" className="bg-[#FFD93D] py-24 md:py-36 px-8 md:px-16 overflow-hidden">
      <div className="w-full">
        {/* Big number + tagline */}
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16 mb-16">
          <span
            className="text-black/10 font-black leading-none select-none flex-shrink-0"
            style={{ fontFamily: "'Bebas Neue', sans-serif",transform: 'translateY(-14px)', fontSize: 'clamp(120px, 20vw, 280px)', lineHeight: 1 }}
          >
            01
          </span>
          <div className="flex-1">
            <h2
              className="text-black font-black uppercase leading-none mb-6"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(48px, 8vw, 120px)' }}
            >
              WHO
              <br />
              WE ARE.
            </h2>
            <p
              className="text-black/80 font-bold uppercase text-xl md:text-2xl tracking-widest max-w-2xl"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            >
              Technology and marketing — united into one growth strategy.
            </p>
          </div>
        </div>

        {/* Description */}
        <div className="bg-black/10 rounded-[30px] p-8 md:p-12 mb-16">
          <p className="text-black/80 font-semibold text-lg md:text-xl leading-relaxed max-w-4xl">
            We are an IT company specialising in custom software development for businesses and individuals, as well as end-to-end digital solutions. Our expertise spans software engineering, IT consulting, and digital marketing — helping companies build technology-driven products, reach their audience, and scale effectively. We support projects at every stage: from idea and analytics through development, launch, and ongoing support.
          </p>
        </div>

        {/* Three bold statements */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-t-4 border-black">
          {[
            { num: '120+', label: 'PROJECTS DELIVERED', sub: 'Web platforms, mobile apps, SaaS tools — built and launched for global clients.' },
            { num: '10+', label: 'YEARS OF EXPERTISE', sub: 'From startups to enterprises — we\'ve seen it all and built it all.' },
            { num: '80+', label: 'HAPPY CLIENTS', sub: 'Businesses across the UK, EU and beyond trust us with their digital growth.' },
          ].map((item) => (
            <div key={item.num} className="border-b-4 md:border-b-0 md:border-r-4 border-black p-8 md:p-12 last:border-r-0">
              <div
                className="font-black text-black leading-none mb-2"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(60px, 8vw, 100px)' }}
              >
                {item.num}
              </div>
              <div
                className="font-black text-black uppercase tracking-widest text-2xl md:text-3xl mb-4"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                {item.label}
              </div>
              <p className="text-black/70 text-lg md:text-xl leading-snug">
                {item.sub}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
